<div layout="column" flex>
  <div class="iwg-summary" fxLayout="row" fxLayout-xs="column" *ngIf="summary">
    <div flex *ngFor="let item of summary" [ngClass]="{'iwg-summary-item-selected': (selectedSummaryItem?.FilterName == item.FilterName 
              && selectedSummaryItem?.FilterValue == item.FilterValue)}" (click)="changeSummary(item)">
      <div class="iwg-value">{{item.Value}}</div>
      <div class="iwg-label">{{item.Name}}</div>
    </div>
  </div>

  <div class="assignmentstabsdiv" [ngClass]="{ 'header-less-tabs': hideFilters }">
    <mat-tab-group animationDuration="0ms" [(selectedIndex)]="selectedTabIndex"
      (selectedTabChange)="onTabChanged($event);">
      <mat-tab *ngFor="let scope of globalScopes" label="{{scope.name}}">
        <ng-container *ngTemplateOutlet="tabContent"></ng-container>
      </mat-tab>
    </mat-tab-group>

    <ng-template #tabContent>
      <div class="vistafilter-wrapper">
        <div class="vistafilter-section1">

          <div class="vistafilter-innersection1" style="font-size: 15px;">{{assignmentLabelPlural}} Active From:</div>
          <div class="vistafilter-innersection2">
            <mat-datepicker-toggle matSuffix [for]="start">
            </mat-datepicker-toggle>
            <mat-form-field appearance="none" color="accent">
              <input matInput [matDatepicker]="start" [(ngModel)]="state.start" (dateChange)="handleDateChange($event)"
                [max]="state.end" name="start">
              <mat-datepicker-toggle matSuffix [for]="start">
                <mat-icon matDatepickerToggleIcon>arrow_drop_down</mat-icon>
              </mat-datepicker-toggle>
              <mat-datepicker #start></mat-datepicker>
            </mat-form-field>

          </div>

          <div class="vistafilter-innersection3">

            <div class="vistafilter-subsection3">To:</div>
            <div class="vistafilter-subsection4">
              <mat-datepicker-toggle matSuffix [for]="end">
              </mat-datepicker-toggle>
              <mat-form-field appearance="none" color="accent">
                <input matInput [matDatepicker]="end" [(ngModel)]="state.end" (dateChange)="handleDateChange($event)"
                  [min] = "state.start">
                <mat-datepicker-toggle matSuffix [for]="end">
                  <mat-icon matDatepickerToggleIcon>arrow_drop_down</mat-icon>
                </mat-datepicker-toggle>
                <mat-datepicker #end></mat-datepicker>
              </mat-form-field>

            </div>

          </div>
        </div>
        <div class="vistafilter-section2">
          <div class="vistafilter-subsection1 vista-country-space" *ngIf="(!hideFilters && state.global_scope != 3)">

            <app-country-select *ngIf="(!hideFilters && state.global_scope != 3)" [(ngModel)]="state.country"
              [idOnly]="true" [alltext]="'All'" [helptext]="''" [preselectedItemId]="selected" (countryChange)="handleCountryChange($event);">
            </app-country-select>

          </div>
          <div class="vistafilter-subsection1 vista-country-space" *ngIf="(!hideFilters && state.global_scope == 3)">
            <app-state-select *ngIf="(!hideFilters && state.global_scope == 3)" [(ngModel)]="state.state" [idOnly]="true"
              [alltext]="'All'" [countryId]="'DC5BD5B9-D52E-445B-8650-794F6C3F15BD'" [helptext]="''"
              [selectedStateCode]="state.state ? state.state : -1"
              (stateChange)="handleStateChange($event);">
            </app-state-select>

          </div>
          <div class="vistafilter-subsection1-search" [ngClass]="{'vistafilter-subsection1-high': (hideFilters), 'vistafilter-subsection1': 
                (!hideFilters)}">

            <mat-form-field style="width: 100%;">
              <mat-label>Search</mat-label>
              <input matInput [(ngModel)]="state.q" (input)="onSearchChange($event.target.value)">
            </mat-form-field>

          </div>
          <div class="vistafilter-subsection2">

            <button mat-icon-button aria-hidden="false" aria-label="Download" class="inputassignicon"
              (click)="exportTable()" [disabled]="(loading || items?.length == 0)">
              <mat-icon>file_download</mat-icon>
            </button>

          </div>
        </div>
      </div>
    </ng-template>
  </div>

 
  <div class="wrapper1" #wrapper1>
    <div class="div1" #div1></div>
  </div>
  <div class="wrapper2" #wrapper2>
   
    <div class="div2" #div2>

      <mat-progress-bar color="accent" mode="indeterminate" *ngIf="loading"></mat-progress-bar>
      <mat-table #listTable matTableExporter matSort [dataSource]="dataSource"  [matSortActive]="state.order_by" 
        [matSortDirection]="state.order"
        [hiddenColumns]="hideColsInExport" (matSortChange)="sortData($event);" style="min-width: 100%;">

       
        <ng-container matColumnDef="IDCol">
          <mat-header-cell *matHeaderCellDef mat-sort-header disableClear class="hidexs"> ID </mat-header-cell>
          <mat-cell *matCellDef="let assignment" class="hidexs"> {{assignment.DisplayID}} </mat-cell>
        </ng-container>

      
        <ng-container matColumnDef="TitleLabel">
          <mat-header-cell *matHeaderCellDef mat-sort-header disableClear> {{assignmentLabel}} </mat-header-cell>
          <mat-cell *matCellDef="let assignment">
              <a matTooltip="{{this.utils.htmlDecode(assignment.Title)}}" matTooltipPosition="below" (click)="navigatePage(assignment.ID, {
              service: state.service,
              page: state.page,
              limit: state.limit,
              order_by: state.order_by,
              order: state.order,
              start: state.start,
              end: state.end,
              q: state.q,
              country: (state.country && state.country.Abbreviation ? state.country.Abbreviation : state.country),
              global_scope: state.global_scope
            })"> {{this.utils.htmlDecode(assignment.Title) | slice:0:40 }}<span *ngIf="assignment.Title.length > 40">...</span></a>
          </mat-cell>
        </ng-container>

       
        <ng-container matColumnDef="EndClient">
          <mat-header-cell *matHeaderCellDef mat-sort-header disableClear class="tabledhead hidexs"> End Client
          </mat-header-cell> 
          <mat-cell *matCellDef="let assignment" class="tabledbody hidexs"> {{assignment.EndClientName}} </mat-cell>
        </ng-container>

      
        <ng-container matColumnDef="WorkerLabel">
          <mat-header-cell *matHeaderCellDef mat-sort-header  disableClear > {{WorkerLabel}}
          </mat-header-cell>
          <mat-cell *matCellDef="let assignment" > {{assignment.Worker}} </mat-cell>
        </ng-container>

        
        <ng-container matColumnDef="ContractorCompany">
          <mat-header-cell *matHeaderCellDef mat-sort-header="BusinessName" id="BusinessName" disableClear class="hidexs"> Contractor Company
          </mat-header-cell>
          <mat-cell *matCellDef="let assignment" class="hidexs"> {{assignment.WorkerCompanyName}} </mat-cell>
        </ng-container>

       
        <ng-container matColumnDef="Manager">
          <mat-header-cell *matHeaderCellDef mat-sort-header="ManagerName" disableClear class="hidexs"> Manager </mat-header-cell>
          <mat-cell *matCellDef="let assignment" class="hidexs"> {{assignment.Manager}} </mat-cell>
        </ng-container>

      
        <ng-container matColumnDef="Country">
          <mat-header-cell *matHeaderCellDef mat-sort-header="CountryName" disableClear class="hidexs"> Country </mat-header-cell>
          <mat-cell *matCellDef="let assignment" class="hidexs"> {{assignment.Country}} </mat-cell>
        </ng-container>

      
        <ng-container matColumnDef="State">
          <mat-header-cell *matHeaderCellDef mat-sort-header disableClear class="hidexs">
          
            State
          </mat-header-cell>
          <mat-cell *matCellDef="let assignment" class="hidexs"> {{assignment.Region}} </mat-cell>
        </ng-container>

       
        <ng-container matColumnDef="BusinessName">
          <mat-header-cell *matHeaderCellDef mat-sort-header disableClear class="hidexs"> Business Name
          </mat-header-cell>
          <mat-cell *matCellDef="let assignment" class="hidexs"> {{assignment.WorkerCompanyName}} </mat-cell>
        </ng-container>

        
        <ng-container matColumnDef="JobTitleLabel">
          <mat-header-cell *matHeaderCellDef mat-sort-header disableClear class="hidexs"> {{JobTitleLabel}}
          </mat-header-cell>
          <mat-cell *matCellDef="let assignment" matTooltip="{{this.utils.htmlDecode(assignment.JobTitle)}}" class="hidexs">
              {{this.utils.htmlDecode(assignment.JobTitle) }} <span *ngIf="assignment.JobTitle.length > 40">...</span>
          </mat-cell>
        </ng-container>

        
        <ng-container matColumnDef="Status">
          <mat-header-cell *matHeaderCellDef mat-sort-header="StatusName" disableClear > Status </mat-header-cell>
          <mat-cell *matCellDef="let assignment" > {{assignment.Status}} </mat-cell>
        </ng-container>

       
        <ng-container matColumnDef="EvaluationStatus">
          <mat-header-cell *matHeaderCellDef mat-sort-header="StatusName" disableClear> <span class="hidexs">Evaluation Status</span><span class="showxs">Status</span> 
          </mat-header-cell>
          <mat-cell *matCellDef="let assignment"> {{assignment.Status}} </mat-cell>
        </ng-container>

        
        <ng-container matColumnDef="QuestionnaireStatus">
          <mat-header-cell *matHeaderCellDef mat-sort-header="QuestionnaireStatusName" disableClear class="hidexs">
            Questionnaire Status
          </mat-header-cell>
          <mat-cell *matCellDef="let assignment" class="hidexs"> {{assignment.QuestionnaireStatus}} </mat-cell>
        </ng-container>

      
        <ng-container matColumnDef="Start">
          <mat-header-cell *matHeaderCellDef mat-sort-header disableClear class="hidexs"> Start </mat-header-cell>
          <mat-cell *matCellDef="let assignment" class="hidexs"> {{assignment.StartDate | date:'MM/dd/yyyy'}}
          </mat-cell>
        </ng-container>

       
        <ng-container matColumnDef="Submitted">
          <mat-header-cell *matHeaderCellDef mat-sort-header="EvaluationStart" disableClear class="hidexs"> Submitted </mat-header-cell>
          <mat-cell *matCellDef="let assignment" class="hidexs"> {{assignment.CreationDate | date:'MM/dd/yyyy'}}
          </mat-cell>
        </ng-container>

       
        <ng-container matColumnDef="Recommendation">
          <mat-header-cell *matHeaderCellDef mat-sort-header="RecommendationLabel" disableClear class="hidexs"> Recommendation
          </mat-header-cell>
          <mat-cell *matCellDef="let assignment" class="hidexs"> {{assignment.Recommendation}} </mat-cell>
        </ng-container>

     
        <ng-container matColumnDef="RecommendationDate">
          <mat-header-cell *matHeaderCellDef mat-sort-header disableClear class="hidexs"> Recommendation Date
          </mat-header-cell>
          <mat-cell *matCellDef="let assignment" class="hidexs"> {{assignment.EvaluationDate | date:'MM/dd/yyyy'}}
          </mat-cell>
        </ng-container>

       
        <ng-container matColumnDef="ExpectedEnd">
          <mat-header-cell *matHeaderCellDef mat-sort-header disableClear class="hidexs"> Expected End
          </mat-header-cell>
          <mat-cell *matCellDef="let assignment" class="hidexs"> {{assignment.ExpectedEndDate | date:'MM/dd/yyyy'}}
          </mat-cell>
        </ng-container>

        
        <ng-container matColumnDef="ActualEnd">
          <mat-header-cell *matHeaderCellDef mat-sort-header="End" disableClear class="hidexs"> Actual End </mat-header-cell>
          <mat-cell *matCellDef="let assignment" class="hidexs"> {{assignment.EndDate  | date:'MM/dd/yyyy'}} </mat-cell>
        </ng-container>

       
        <ng-container matColumnDef="Hours">
          <mat-header-cell *matHeaderCellDef mat-sort-header="HoursLabel" disableClear class="hidexs"> Hours </mat-header-cell>
          <mat-cell *matCellDef="let assignment" class="hidexs"> {{assignment.Hours | number : '1.2-2'}} </mat-cell>
        </ng-container>

       
        <ng-container matColumnDef="RegularHours">
          <mat-header-cell *matHeaderCellDef mat-sort-header disableClear class="hidexs"> Regular
          </mat-header-cell>
          <mat-cell *matCellDef="let assignment" class="hidexs"> {{assignment.Reg | number : '1.2-2'}} </mat-cell>
        </ng-container>

       
        <ng-container matColumnDef="OT">
          <mat-header-cell *matHeaderCellDef mat-sort-header="OvertimeHours" disableClear class="hidexs"> OT </mat-header-cell>
          <mat-cell *matCellDef="let assignment" class="hidexs"> {{assignment.OT | number : '1.2-2'}} </mat-cell>
        </ng-container>

      
        <ng-container matColumnDef="DT">
          <mat-header-cell *matHeaderCellDef mat-sort-header="DoubletimeHours" disableClear class="hidexs"> DT </mat-header-cell>
          <mat-cell *matCellDef="let assignment" class="hidexs"> {{assignment.DT | number : '1.2-2'}} </mat-cell>
        </ng-container>

       
        <ng-container matColumnDef="Expenses">
          <mat-header-cell *matHeaderCellDef mat-sort-header="ExpensesLabel" disableClear class="hidexs"> Expenses </mat-header-cell>
          <mat-cell *matCellDef="let assignment" class="hidexs">
            {{assignment.Expenses | currency: ('$' || '') : 'symbol-narrow' : '1.2-2'}} ({{assignment.EntityCurrencyCode}})
          </mat-cell>
        </ng-container>

       
        <ng-container matColumnDef="PayRate">
          <mat-header-cell *matHeaderCellDef mat-sort-header="PayRateLabel" disableClear class="hidexs"> Pay Rate </mat-header-cell>
          <mat-cell *matCellDef="let assignment" class="hidexs"> {{assignment.Payrate}} </mat-cell>
        </ng-container>

      
        <ng-container matColumnDef="PayAmount">
          <mat-header-cell *matHeaderCellDef mat-sort-header disableClear class="hidexs"> Pay Amount </mat-header-cell>
          <mat-cell *matCellDef="let assignment" class="hidexs">
            {{assignment.Pay | currency: ('$' || '') : 'symbol-narrow' : '1.2-2'}} ({{assignment.EntityCurrencyCode}})
          </mat-cell>
        </ng-container>

       
        <ng-container matColumnDef="BillAmount">
          <mat-header-cell *matHeaderCellDef mat-sort-header disableClear class="hidexs"> Bill Amount </mat-header-cell>
          <mat-cell *matCellDef="let assignment" class="hidexs">
            {{assignment.Bill | currency: ('$' || '') : 'symbol-narrow' : '1.2-2'}} ({{assignment.EntityCurrencyCode}})
          </mat-cell>
        </ng-container>

        
        <ng-container matColumnDef="PayStructure">
          <mat-header-cell *matHeaderCellDef mat-sort-header disableClear class="hidexs"> Pay Structure
          </mat-header-cell>
          <mat-cell *matCellDef="let assignment" class="hidexs"> {{assignment.SalaryPerTimeframeStructure}} </mat-cell>
        </ng-container>

       
        <ng-container matColumnDef="ProjectAmount">
          <mat-header-cell *matHeaderCellDef mat-sort-header="ProjectAmountLabel" disableClear class="hidexs"> Project Amount
          </mat-header-cell>
          <mat-cell *matCellDef="let assignment" class="hidexs"> {{assignment.ProjectAmount}} </mat-cell>
        </ng-container>

       
        <ng-container matColumnDef="PartnerInvoiceTotalAmount">
          <mat-header-cell *matHeaderCellDef mat-sort-header disableClear class="hidexs"> Pay Amount </mat-header-cell>
          <mat-cell *matCellDef="let assignment" class="hidexs"> {{assignment.PartnerInvoiceTotal}} </mat-cell>
        </ng-container>

       
        <ng-container matColumnDef="OprMenu">
          <mat-header-cell *matHeaderCellDef class="hidexs"></mat-header-cell>
          <mat-cell *matCellDef="let assignment" class="hidexs customclass">
            <button mat-icon-button [matMenuTriggerFor]="elementMenu" aria-label="Menu">
              <mat-icon>more_vert</mat-icon>
            </button>

            <mat-menu #elementMenu="matMenu" backdropClass="submenualignment" class="submenu" xPosition="before">
              <button mat-menu-item (click)="navigatePage(assignment.ID, {
                service: state.service,
                page: state.page,
                limit: state.limit,
                order_by: state.order_by,
                order: state.order,
                start: state.start,
                end: state.end,
                q: state.q,
                country: (state.country && state.country.Abbreviation ? state.country.Abbreviation : state.country),
                global_scope: state.global_scope
              })">
                Show Details
              </button>

              <button mat-menu-item *ngIf="assignment.Status=='Evaluation Complete' && (assignment.Recommendation=='Pass' 
                          || assignment.Recommendation=='No Pass')"
                (click)="showTransferAssignmentDialog($event,assignment.ID, 0,'EOR')">
                Transfer to EOR
              </button>
             
              <button mat-menu-item *ngIf="assignment.Status=='Evaluation Complete' && (assignment.Recommendation=='Pass') 
                        && (assignment.TransfterQuoteID != null)"
                (click)="showTransferAssignmentDialog($event,assignment.ID,assignment.TransfterQuoteID, 'AOR', false)">
                Transfer to AOR
              </button>
             

             
              <button mat-menu-item *ngIf="assignment.StatusID == 1 && assignment.IsTransferToAOR == true"
                (click)="edit($event, assignment.ID)">
                Edit
              </button>

              <button mat-menu-item *ngIf="assignment.StatusID == 1 && assignment.IsTransferToAOR != true"
                (click)="edit($event, assignment.ID)">
                Edit
              </button>
             
            </mat-menu>

          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
      </mat-table>

    </div>
  </div>

  <mat-paginator [length]="totalRecords" [pageSize]="state.limit" (page)="pageEvent = $event; naviatePageTo($event)" class="myvista-paginator"
    [pageSizeOptions]="[25, 100, 500, 1000, 10000]" showFirstLastButtons>
  </mat-paginator>
</div>